import { render, staticRenderFns } from "./PickUpInfo.vue?vue&type=template&id=b9008956&scoped=true"
import script from "./PickUpInfo.vue?vue&type=script&lang=js"
export * from "./PickUpInfo.vue?vue&type=script&lang=js"
import style0 from "./PickUpInfo.vue?vue&type=style&index=0&id=b9008956&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9008956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9008956')) {
      api.createRecord('b9008956', component.options)
    } else {
      api.reload('b9008956', component.options)
    }
    module.hot.accept("./PickUpInfo.vue?vue&type=template&id=b9008956&scoped=true", function () {
      api.rerender('b9008956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/PickUpInfo.vue"
export default component.exports